import { z } from 'zod';

export const OperatoreCacheSchema = z.object({
  idFenice: z.number(),
  nome: z.string(),
  cognome: z.string(),
  territorio: z.string().nullable(),
  updatedAt: z.string().nullable(),
});

export type OperatoreCache = z.infer<typeof OperatoreCacheSchema>;

export interface OperatoreCacheInsert {
  idFenice: number;
  nome: string;
  cognome: string;
  territorio: string | null;
}
